import script from "./InternalService.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalService.vue?vue&type=script&setup=true&lang=js"

import "./InternalService.vue?vue&type=style&index=0&id=0c7b2c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c7b2c50"]])

export default __exports__